import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface SectionWrapperProps {
  includeBottomPadding: boolean
}
export const SectionWrapper = styled.div<SectionWrapperProps>`
  margin-top: ${Spacing.S16};
  margin-bottom: ${({ includeBottomPadding }) => (includeBottomPadding ? Spacing.S16 : 0)};
`
